module.exports = __webpack_public_path__ + "components/home-header/static/header-3--large@2x-0578c76651388a53afd2666d93ba0e1e.jpg";